<template>
  <div id="route-panel-footer">
    <div id="route-stats">
      <div class="stat">
        <div class="stat-val">{{ route.places.length }}</div>
        <div class="stat-desc">{{ $tc("stats.stops", route.places.length) }}</div>
      </div>
      <div class="stat">
        <div class="stat-val">
          <span v-if="!route.loading">{{ $filters.distance(route.distance) }}</span>
          <span v-else>-</span>
        </div>
        <div class="stat-desc">{{ $t("stats.distance") }}</div>
      </div>
      <div class="stat" v-tooltip="`<b>${$filters.duration(route.durationDriving)}</b> kørsel<br> <b>${$filters.duration(route.duration - route.durationDriving)}</b> pause`">
        <div class="stat-val">
          <span v-if="!route.loading">{{ $filters.duration(route.duration) }}</span>
          <span v-else>-</span>
        </div>
        <div class="stat-desc">{{ $t("stats.duration") }}</div>
      </div>
      <div v-if="false" class="stat no-mobile">
        <div class="stat-val">
          <span v-if="!route.loading">{{ $filters.duration(route.duration - route.durationDriving) }}</span>
          <span v-else>-</span>
        </div>
        <div class="stat-desc">{{ $t("stats.break_duration") }}</div>
      </div>
    </div>

    <AppButton v-if="store.user.isOwner(route.id)" @click="goLive" :loading="state.loading" :disabled="route.loading || route.places.length < 2"
      id="button-go-live" color="primary" icon="play_arrow" class="no-print" >
        {{ state.loading ? 'Starter' : 'Start' }}
    </AppButton>
  </div>
</template>

<script lang="ts">
import { store } from '@/store'
import { defineComponent, reactive } from 'vue'

export default defineComponent({
  name: 'RouteStats',
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  setup(props) {

    const state = reactive({
      loading: false
    })

    const subscription = store.user.get(state => state.subscription)

    async function goLive() {
      state.loading = true
      await store.route.goLive(props.route.id)
      state.loading = false
    }
    return { state, store, subscription, goLive }
  }
})
</script>

<style lang="scss" scoped>
#button-go-live {
  position: absolute;
  right: var(--side-padding);
}
#route-panel-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#route-stats {
  display: flex;
  padding: 1rem 0;
  .stat {
    padding: 0 1rem;
    border-left: 1px solid var(--color-divider);
    &:first-child {
      padding-left: 0;
      border: 0;
    }

    &-val {
      font-weight: 600;
      font-size: 1.125rem;
      line-height: 1.2;
    }
    &-desc {
      font-weight: 400;
      font-size: .75rem;
      text-transform: lowercase;
      color: var(--text-color-secondary);
    }
  }
}
@media only screen and (max-width: 450px) {
  #route-stats {
    .stat {
      //padding: .5rem; 
      &-val {
        //font-size: 0.825rem;
      }
      &-desc {

      }
    }
  }
}
</style>